import {
  Box,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import './MessageBubble.css';

const MessageBubble = ({ id, value, title, onSave, name, recordId, disabled, ...rest }) => {
  const [openModal, setOpenModal] = useState(false);
  const [inputValue, setInputValue] = useState(value || '');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClickOpen = () => {
    setInputValue(value || '');
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleSave = async () => {
    try {
      setIsSubmitting(true);
      onSave({ name, value: inputValue, recordId });
    } catch (error) {
    } finally {
      handleClose();
      setIsSubmitting(false);
    }
  };

  return (
    <Box className='message-bubble' id={id} {...rest}>
      <FontAwesomeIcon
        icon={'comment-dots'}
        className={`message-bubble__icon ${openModal ? 'message-bubble__icon--active' : ''} ${disabled ? 'message-bubble__icon--disabled' : ''}`}
        onClick={disabled ? undefined : handleClickOpen}
      />
      <>
        <Dialog open={openModal} onClose={handleClose}>
          <DialogContent className='message-bubble__dialog'>
            <DialogContentText>{title || ''}</DialogContentText>
            <TextField
              autoFocus
              className='custom-text-field'
              value={inputValue}
              margin='dense'
              id={`message-value-${id}`}
              name={`${name}`}
              type='text'
              onChange={(evt) => setInputValue(evt.target.value)}
              inputProps={{
                maxLength: 500,
                spellCheck: false
              }}
              fullWidth
              variant='standard'
              multiline
              minRows={6}
            />
          </DialogContent>
          <DialogActions>
            <Button
              size='small'
              onClick={handleClose}
              disabled={isSubmitting}
              startIcon={<FontAwesomeIcon icon='circle-xmark' />}
              style={{ padding: '6px 16px' }}
              className={'custom-save__button message-bubble_cancel-button'}
            >
              Cancel
            </Button>

            <Button
              size='small'
              onClick={handleSave}
              disabled={isSubmitting}
              startIcon={<FontAwesomeIcon icon='circle-check' />}
              style={{ padding: '6px 16px' }}
              className={'custom-save__button message-bubble_save-button'}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </>
    </Box>
  );
};

export default MessageBubble;
